import type { KnownSearchParams } from '../../page'
import {
  COINS_OG_PAGE_SIZE,
  COINS_PAGE_SIZE,
  type CoinTab,
  coinTabValues,
  defaultCoinTab,
  getCoinTabs,
} from './configs'

export function normalizeSearchParams(searchParams: KnownSearchParams, isOGPrice?: boolean) {
  const { page, tab } = searchParams

  const pageSize = isOGPrice ? COINS_OG_PAGE_SIZE : COINS_PAGE_SIZE
  const coinTabs = getCoinTabs(pageSize)

  const currentPage = page && Number.isSafeInteger(Number(page)) ? Number(page) : 1

  const currentCoinTab =
    tab && coinTabValues.includes(tab as CoinTab)
      ? (coinTabs.find(o => o.value === tab) ?? defaultCoinTab)
      : defaultCoinTab

  return {
    currentPage,
    currentCoinTab,
  }
}
